<ng-container *ngIf="showBloque">
  <div class="bloque-comentarios">
    <div class="google-news-desktop-only">
      <app-google-news-banner></app-google-news-banner>
    </div>
    <ng-container *ngIf="showTitulo">
      <div class="titulo-comentarios">
        <h3>{{ numComentarios }} {{ numComentarios == 1 ? "comentario" : "Comentarios" }}</h3>
        <div class="compartir-rss">
          <app-rrss-buttons [url]="noticia?.urlNoticia" [text]="noticia?.tituloVideo">
            <app-icon-share toggleIcon [shared]="true"></app-icon-share>
          </app-rrss-buttons>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="showTextarea">
      <app-send-comment-textarea [idVideo]="idVideo" (onSendComment)="onSendComment($event)"></app-send-comment-textarea>
      <ng-container *ngIf="showLogin && !userId">
        <div class="login"><span (click)="openLoginDialog()" (keypress)="openLoginDialog()">Inicia sesión</span> o <span (click)="openRegistroDialog()" (keypress)="openRegistroDialog()">registrate</span> para comentar</div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="showComentarios">
      <div class="contenedor-comentarios">
        <ng-container *ngFor="let comentario of comentariosPaginados; trackBy: trackByComentario">
          <app-comment [idVideo]="idVideo" [comment]="comentario" [showFecha]="showFecha" [showNombre]="showNombre"></app-comment>
        </ng-container>
        <ng-container *ngIf="comentarios?.length > 4">
          <mat-paginator [length]="comentarios?.length" [pageSize]="numeroComentariosPagina" [pageSizeOptions]="pageSizeOptions" [showFirstLastButtons]="showFirstLastButtons" (page)="cambiarPagina($event)"> </mat-paginator>
        </ng-container>
      </div>
    </ng-container>
  </div>
</ng-container>
